var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.showDialog, persistent: "", "max-width": "650px" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _vm.type === "modal"
                    ? [
                        _c(
                          "DialogContainerModal",
                          {
                            attrs: {
                              title: _vm.title,
                              icon: _vm.icon,
                              isLoading: _vm.isLoading,
                            },
                            on: {
                              onCancelClicked: function ($event) {
                                return _vm.$emit("onCancelClicked")
                              },
                            },
                          },
                          [_vm._t("default")],
                          2
                        ),
                      ]
                    : [
                        _c(
                          "DialogContainerConfirmation",
                          {
                            attrs: {
                              title: _vm.title,
                              icon: _vm.icon,
                              isLoading: _vm.isLoading,
                            },
                          },
                          [_vm._t("default")],
                          2
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("Toolbar", {
                    attrs: {
                      isDark: false,
                      actions: _vm.toolbarActions,
                      isLoading: _vm.isLoading,
                    },
                    on: { onClicked: (val) => _vm.$emit(val) },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }